<template>
  <RichTextElement
    v-for="child in elements"
    :key="child.tag"
    :element="child"
    :body-variant="bodyVariant" />
</template>

<script setup lang="ts">
import type { UmbracoRichTextElement } from '@gro-up/types'

import type { TypographyVariant } from '../Typography/Typography.vue'

import RichTextElement from './RichTextElement.vue'

defineProps<{
  elements: UmbracoRichTextElement[]
  bodyVariant?: TypographyVariant
}>()
</script>
